<script lang="ts">
  import { getCopy } from "../../lib/stores/copy";
  import SharedHeading from "../SharedHeading.svelte";
  import { errorRoutes, navigateToPath } from "../../lib/routing";
  import BaseStep from "./BaseStep.svelte";
  import Button from "../Button.svelte";
  import { retryRedirect } from "../../lib/helpers/navigation";
  import RoutePaths from "../../lib/constants/routePaths";
  import Youtube from "../Youtube.svelte";
  import Countdown from "../Countdown.svelte";
  import { sessionStore } from "../../lib/stores/session";
  
  export let currentRoute: { name: string; path: string };

  const getErrorPageKey = (currentRoute: { name: string; path: string }) => {
    return errorRoutes.find(({ path }) => path === currentRoute.path)?.id;
  };

  const onCountdownComplete = () => {
    disableRetryButton = false;
  };

  $: isShowBackButton = currentRoute.path !== RoutePaths.CAMPAIGN_OVER;
  $: showCountdown = currentRoute.path === RoutePaths.RATE_LIMIT_WITH_COUNTDOWN;
  $: errorPageKey = getErrorPageKey(currentRoute);
  $: {
    if (!errorPageKey) navigateToPath("/error");
  }
  $: copy = $getCopy(errorPageKey ?? "") as Record<string, string>;
  $: retryButtonText = copy.retryText ?? copy.tryAgainLink ?? copy.buttonText;
  $: disableRetryButton = showCountdown;
</script>

<BaseStep {currentRoute} showBackButton={isShowBackButton}>
  <svelte:fragment slot="content">
    <SharedHeading headerCopy={copy.headerCopy} subHeaderCopy={copy.subHeaderCopy} />
    {#if showCountdown}
      <Countdown onCountdownComplete={onCountdownComplete} nextRetryAt={$sessionStore.turnstileTokenData?.retryAt} />
    {/if}
    <slot name="error"></slot>
    <slot name="button">
      {#if retryButtonText}
        <Button disabled={disableRetryButton} primary class="mt-8 lg:max-w-max" on:click={retryRedirect}>{retryButtonText}</Button>
      {/if}
    </slot>
    {#if copy.customHtml}
      {@html copy.customHtml}
    {/if}
    <Youtube videoId={copy.videoId} />
  </svelte:fragment>
</BaseStep>
